import { QuoteRepository } from './repository';
import { QuoteService } from './service';
import { Quote } from './classes/quote';
import { CreateQuoteBody, EnvironmentName } from './types/quote';
class Sensible {
  private partnerID!: string;
  private productID!: string;
  private theme: Record<string, unknown> = {};
  private selectGuaranteeCallback: (quote: Quote) => void = () => {};
  private unselectGuaranteeCallback: (quote: Quote) => void = () => {};
  private createGuaranteeCallback: (quote: Quote) => void = () => {};

  quote!: QuoteService;

  configure(partnerID: string, productID: string, env?: EnvironmentName) {
    this.partnerID = partnerID;
    this.productID = productID;

    const quoteRepository = new QuoteRepository(partnerID, productID, env);
    this.quote = new QuoteService(quoteRepository);
  }

  isConfigured() {
    return !!this.partnerID && !!this.productID;
  }

  setTheme(theme: Record<string, unknown>) {
    this.theme = theme;
    const component = this.getComponent();
    if (component) {
      component.theme = this.theme;
    }
  }

  setSelectGuaranteeCallback(callback: (quoteData: Quote) => void) {
    this.selectGuaranteeCallback = callback;
    const component = this.getComponent();
    if (component) {
      component.selectGuaranteeCallback = this.selectGuaranteeCallback;
    }
  }
  setUnselectGuaranteeCallback(callback: (quoteData: Quote) => void) {
    this.unselectGuaranteeCallback = callback;
    const component = this.getComponent();
    if (component) {
      component.unselectGuaranteeCallback = this.unselectGuaranteeCallback;
    }
  }

  setCreateGuaranteeCallback(callback: (quote: Quote) => void) {
    this.createGuaranteeCallback = callback;
  }
  async mountComponent(config: CreateQuoteBody) {
    const component = this.getComponent();
    if (!component) {
      throw new Error('ELEMENT NOT FOUND');
    }

    component.quote = new Quote();
    component.mounted = true;
    component.theme = this.theme;
    component.selectGuaranteeCallback = this.selectGuaranteeCallback;
    component.unselectGuaranteeCallback = this.unselectGuaranteeCallback;

    try {
      const quote = await this.quote.createQuote(config);
      this.createGuaranteeCallback?.(quote);
      component.quote = quote;
    } catch (e) {
      component.error = e;
    }
  }

  private getComponent() {
    return document.querySelector('sensible-weather-guarantee');
  }
}

export { Sensible };
